export default __webpack_public_path__ + "static/media/successCheckEmpty.edb5d3e8.svg";